import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KitesurfingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"kitesurfing"}/>
}
